import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import Apply from './pages/Apply';
import Contact from './pages/Contact';
import AdminPanel from './pages/AdminPanel';
import StudentLogin from './pages/StudentLogin';
import StudentRegister from './pages/StudentRegister';
import StudentPortal from './pages/StudentPortal';
import StudentVerification from './pages/StudentVerification';
import Guide from './pages/Guide';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/student/login" element={<StudentLogin />} />
        <Route path="/student/register" element={<StudentRegister />} />
        <Route path="/student/portal" element={<StudentPortal />} />
        <Route path="/student-verification" element={<StudentVerification />} />
        <Route path="/sorgulama" element={<StudentVerification />} />
        <Route path="/kılavuz" element={<Guide />} />
        <Route path="/kilavuz" element={<Guide />} />
      </Routes>
    </Router>
  );
}

export default App;
